var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{class:_vm.className,attrs:{"target":_vm.target,"href":_vm.computedHref,"disabled":_vm.disabled}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }